module.exports = __webpack_public_path__ + "img/noexit.1bd8504d.png";